import { Stage } from "./Stage";
import { Speech } from "./TalkPanel";

export class Stage0 extends Stage {
    constructor() {
        super();
        this.pushCheckPoint(0, 0);
        this.pushPlayer(0, 0);
        this.asCameraCenter();
        this.pushWall(-400, -400, 200, 700);
        this.pushWall(300, -400, 200, 700);
        this.pushWall(-400, 300, 900, 200);
        this.pushWall(-200, -900, 150, 650);
        this.pushWall(150, -900, 150, 650);
        this.pushWall(-400, -1300, 200, 550);
        this.pushDescription(-50, -1250, 200, 100, "Enter");
        this.s$fontSize = 6;
        this.pushWall(300, -1000, 200, 250);
        this.pushWall(300, -1300, 200, 100);
        this.pushWall(-400, -1500, 900, 200);
        this.pushSignboard(0, -1150, [
            new Speech({
                content: 'これが<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>ね。',
                speakerName: "謎の声",
            }),
            new Speech({
                content: "(どうみても看板だ)",
            }),
            new Speech({
                content: "これは看板です。",
                speakerName: "看板",
            }),
            new Speech({
                content: "(どうやら看板のようだ)",
            }),
            new Speech({
                content: "右側は行き止まりのように見えますが、思い切ってそのまま進んでみてください。",
                speakerName: "看板",
            }),
            new Speech({
                content: 'また、<font style="color:#0000dd">Shiftキー</font>を押している間は速く動けますよ。',
                speakerName: "看板",
            }),
            new Speech({
                content: "(記憶の欠片ではなさそうだ)",
            }),
        ]);
        this.pushWall(500, -1350, 1100, 150);
        this.pushWall(500, -1000, 800, 150);
        this.pushSquare(1000, -1200, 100, 200);
        this.pushWall(1500, -1200, 100, 200);
        this.pushWall(1400, -1000, 200, 1000);
        this.pushWall(1100, -850, 200, 450);
        this.pushWall(900, -400, 400, 200);
        this.pushFakePanel(500, -350, 400, 100);
        this.pushWall(900, 0, 700, 200);
        this.pushDescription(650, -200, 100, 100, "↓");
        this.s$fontSize = 12;
        this.pushWall(650, 100, 100, 250);
        this.pushWall(500, 450, 900, 50);
        this.pushWall(750, 300, 550, 50);
        this.pushWall(1400, 200, 200, 300);
        this.pushWall(1250, 350, 50, 100);
        this.pushSignboard(1300, 350, [
            new Speech({
                content: '<font style="color:#dd0000">自分は"人間"だ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(1150, 350, [
            new Speech({
                content: "さっきの矢印は嘘吐きですよ。",
                speakerName: "看板",
            }),
        ]);

        this.pushGoal(725, -675, 100, 100);

        // this.pushCheckPoint(700, -200);
        // this.respawnCheckPoint(1);

        this.create();
    }

    protected loop(): void {}
}
